module.exports = __webpack_public_path__ + "components/app-buttons/static/app-store-15498992d55a102a01763a3165fdf949.svg";